// extracted by mini-css-extract-plugin
export default {"LiveFeedContainer":"MobileLiveFeed_LiveFeedContainer__81DOR"};